module.exports = __webpack_public_path__ + "images/flag-07.png?eecb15de88d01a98478b0023d903a041";